<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CRow>
            <CCol>
              <div>
                <CButton
                  @click="showHideFormCreate"
                  color="primary"
                  class="float-left ml-1 pt-2"
                >
                  <CIcon name="cil-cloud-upload" />
                  <span class="p-2">Upload Data Winner Aggregator</span>
                </CButton>
              </div>
              <div class="form-create-bulk" v-if="showFormCreate">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="10" class="">
                        <h5 id="traffic" class="card-title ml-3 mb-0">
                          Upload Berkas
                        </h5>
                      </CCol>
                      <CCol
                        sm="2"
                        class="d-flex justify-content-end"
                        @click="hideFormCreate"
                        ><CIcon type="button" name="cil-x-circle"
                      /></CCol>
                    </CRow>
                  </CCardHeader>
                  <CCardBody class="border-bottom-0">
                    <CRow>
                      <CCol sm="12" class="ml-3">
                        <h5 id="traffic" class="card-title mb-3">
                          Upload Winnner Aggregator
                        </h5>
                      </CCol>
                      <CCol sm="12" class="ml-3">
                        <div class="label-input-file pt-1">
                          <label for="label-file-wording" class="btnd"
                            >Pilih Berkas :
                          </label>
                          <label class="file-name-inputs">
                            {{ fileName }}</label
                          >
                        </div>
                      </CCol>
                      <CCol sm="12">
                        <input
                          @change="setFile($event)"
                          type="file"
                          id="uploads"
                          class="file"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol sm="7" class="ml-3 mt-3">
                        <CSelect
                          class="select-class-upload"
                          label="Aggregator"
                          :options="optionsAggregator"
                          required
                          horizontal
                          v-model="aggregatorUpload"
                          @change="handleAggregatorUpload"
                        />
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CRow class="form-group">
                    <CCol :col="6">
                      <CButton
                        @click="exportTemplate()"
                        color="primary"
                        class="float-left btn-download mt-2 mb-2"
                      >
                        Download Template
                      </CButton>
                    </CCol>
                    <CCol :col="6" class="">
                      <CButton
                        @click="bulkInsert()"
                        color="primary"
                        class="float-right btn-upload mt-2 mb-2"
                      >
                        Upload
                      </CButton>
                    </CCol>
                  </CRow>
                </CCard>
              </div>
            </CCol>
            <CRow class="float-right">
              <div class="select-list mr-3">
                <CCol>
                  <CSelect
                    class="select-class"
                    label="Aggregator"
                    :options="optionsAggregator"
                    required
                    horizontal
                    v-model="aggregator"
                    @change="handleAggregator"
                  />
                </CCol>
              </div>
            </CRow>
          </CRow>
        </CCardBody>
        <CCardFooter style="text-align: center;">
          <CDataTable
            hover
            striped
            :items="aggregatorList"
            :fields="fields"
            :items-per-page="10"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          />
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="paginateData('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="paginateData('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ page }}</div>
            <div class="pagination-btn-next" @click="paginateData('NEXT')">
              next
            </div>
          </div>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";
import XLSX from "xlsx";
export default {
  name: "Aggregator",
  data() {
    return {
      aggregatorList: [],
      fields: [
        { key: "leaderboard_rank", label: "No Posisi", _style: "width:15%" },
        { key: "leaderboard_phone", label: "No Handphone", _style: "width:25%" },
        { key: "leaderboard_name", label: "Nama", _style: "width:40%" },
        { key: "leaderboard_total_stt", label: "Total STT", _style: "width:20%" },
      ],
      fileName: "",
      fileData: "",
      fileUsername: "",
      fileDataUsername: "",
      page: 1,
      aggregator: "lincah",
      aggregatorUpload: "lincah",
      optionsAggregator: [
        { label: "Lincah", value: "lincah" },
        { label: "Everpro", value: "everpro" },
        { label: "Mengantar", value: "mengantar" },
      ],
      templateAggregator: [
        {
          rank: "1",
          name: "A**** B****",
          phone_number: "628****12345",
          stt_count: "100"
        },
      ],
      showFormCreate: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  beforeMount() {
    this.authentication();
    this.paginateData();
  },
  methods: {
    handleAggregator(event) {
      this.aggregator = event.target.value;
      this.paginateData('');
    },
    handleAggregatorUpload(event) {
      this.aggregatorUpload = event.target.value;
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    showHideFormCreate() {
      this.fileName = "";
      this.fileData = "";
      this.showFormCreate = !this.showFormCreate;
    },
    hideFormCreate() {
      this.fileName = "";
      this.fileData = "";
      this.showFormCreate = false;
    },
    setFile(file) {
      var fullPath = file.target.value;
      if (fullPath) {
        var startIndex =
          fullPath.indexOf("\\") >= 0
            ? fullPath.lastIndexOf("\\")
            : fullPath.lastIndexOf("/");
        var filename = fullPath.substring(startIndex);
        if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
          filename = filename.substring(1);
        }
        const extension = filename.split(".");
        if (extension[extension.length - 1] !== "xlsx") {
          this.responseMessage("error", "Format file harus excel");
          this.fileName = "";
          this.fileData = "";
        } else {
          this.fileName = filename;
          this.fileData = file.target.files[0];
        }
      }
    },
    responseMessage(icon, message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message,
      });
    },
    paginateData(payload) {
      if (payload === "NEXT") {
        this.page = this.page + 1;
      } else if (payload === "BACK") {
        if (this.page > 1) {
          this.page = this.page - 1;
          window.scrollTo(0, 0);
        }
      } else if (payload === "REFRESH") {
        this.page = 1;
        window.scrollTo(0, 0);
      } else {
        this.page = 1;
      }
      axios
        .get(
          `${this.domain}/v1/leaderboard/${this.aggregator}/rank?page=${this.page}&per_page=10`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.list.length > 0) {
            if (this.page > 1) {
              window.scrollTo(0, 0);
            }
            this.aggregatorList = response.data.data.list;
          } else if (payload === "NEXT") {
            this.page = this.page - 1;
          } else if (response.data.data.list.length === 0 && payload === "") {
            this.aggregatorList = response.data.data.list;
          }
        })
        .catch((e) => {
          console.log("error :", e);
          Swal.fire({
            icon: "error",
            title: "Gagal mendapatkan list data",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    bulkInsert() {
      if (this.fileData !== "") {
        var form = new FormData();
        var path = "";
        path = "/v1/leaderboard/upload";
        form.append("leaderboard_file", this.fileData);
        form.append("leaderboard_name", this.aggregatorUpload);

        axios
          .post(`${this.domain}${path}`, form, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              this.responseMessage("success", "Data berhasil diupload");
              this.fileName = "";
              this.fileData = "";
              this.showFormCreate = false;
            }
            this.paginateData("");
          })
          .catch((err) => {
            this.responseMessage("error", err.response.data.message.id);
          });
      } else {
        this.responseMessage(
          "error",
          "Silahkan pilih berkas yang akan di upload"
        );
      }
    },
    exportTemplate() {
      var aggregatorTemplate = XLSX.utils.json_to_sheet(this.templateAggregator);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, aggregatorTemplate, "Sheet1");
      XLSX.writeFile(wb, "template_data_winner_aggregator.xlsx");
    },
  },
};
</script>

<style scoped>
@import url("./Aggregator.css");
</style>
